import React from 'react';
import PropTypes from 'prop-types';
import ToastBanner from '../ToastBanner';

const ErrorBanner = ({
  children,
  showError,
  errorTitle,
  onCloseErrorMessage,
  hyperlink,
}) => {
  if (!showError) return null;

  return (
    showError && (
    <ToastBanner type="error" title={errorTitle} onClickCloseButton={onCloseErrorMessage}>
      {children}
      {
        hyperlink.url && (
          <div>
            <a href={hyperlink.url}>
              {hyperlink.text}
            </a>
          </div>
        )
      }
    </ToastBanner>
    )
  );
};

ErrorBanner.propTypes = {
  showError: PropTypes.bool,
  children: PropTypes.node.isRequired,
  errorTitle: PropTypes.string,
  onCloseErrorMessage: PropTypes.func.isRequired,
  hyperlink: PropTypes.object,
};

ErrorBanner.defaultProps = {
  showError: false,
  errorTitle: undefined,
  hyperlink: {},
};

export default ErrorBanner;
